<script setup>
import { watch } from 'vue'
import { RouterView } from 'vue-router'
import { useI18n } from 'vue-i18n'
import BottomNav from '@/components/BottomNav.vue'
import OfflineBanner from '@/components/OfflineBanner.vue'
import ToastStack from '@/components/ToastStack.vue'
import { useAuthStore } from '@/stores/auth.js'
import { persistLocale } from '@/i18n.js'

const auth = useAuthStore()
const { locale } = useI18n()

// A signed-in user's saved preference always wins over whatever detectLocale() guessed at
// boot (stored locale / navigator.language — see src/i18n.js). Persisting it back here is
// what lets the *next* boot start in the right language before auth.fetchMe() has even
// resolved — session auth is cookie-based, so there's nothing synchronous to read from the
// user object that early.
watch(
  () => auth.user?.locale,
  (next) => {
    if (next) {
      locale.value = next
      persistLocale(next)
    }
  },
  { immediate: true }
)
</script>

<template>
  <div class="min-h-dvh bg-cream">
    <OfflineBanner />
    <main class="mx-auto w-full max-w-content px-5 pb-28 pt-6">
      <RouterView />
    </main>
    <ToastStack />
    <BottomNav />
  </div>
</template>
